export default __webpack_public_path__ + "static/media/archi_slider_6.63fcb449.webp";